import React from "react";
import { getLevelAndTitle } from "../utils/levelUtils";

const Dashboard = ({ user, userProfile }) => {
  if (!userProfile) return <div className="dashboard-card">Loading...</div>;

  const { totalXP, level, currentTitle } = userProfile;
  const { currLevelXP, nextLevelXP } = getLevelAndTitle(totalXP);
  const hunterName =
    userProfile.displayName ||
    user?.rawUser?.user_metadata?.user_name ||
    user?.displayName ||
    "Hunter";

  return (
    <div className="dashboard-card dashboard-card--centered">
      <h3>Welcome, {hunterName}!</h3>

      <div className="dashboard-meta">
        <p className="dashboard-meta-line">
          <span className="dashboard-meta-label">Title:</span>{" "}
          <span className="dashboard-meta-value">{currentTitle}</span>
        </p>
        <p className="dashboard-meta-line">
          <span className="dashboard-meta-label">Level:</span>{" "}
          <b className="dashboard-level-value">{level}</b>
        </p>
      </div>

      <div className="dashboard-progress">
        <div className="dashboard-progress-track">
          <div
            className="dashboard-progress-fill"
            style={{ width: `${Math.floor((currLevelXP / nextLevelXP) * 100)}%` }}
          />
        </div>
        <span className="dashboard-progress-copy">
          {currLevelXP} / {nextLevelXP} XP to next level
        </span>
      </div>
    </div>
  );
};

export default Dashboard;
